export const unique = <T>(target: T[]): T[] => {
  return Array.from(new Set(target));
};
